import type { DistrictMiniEntity } from '@/features/branch/domain/entities/DistrictMiniEntity'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'

export class CouponRegionEntity {
  region?: RegionMiniEntity
  districts?: Array<DistrictMiniEntity> | null
}
